import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function AdminLogin() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({ email: '', password: '' });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            const response = await fetch('http://localhost:5000/api/auth/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            });
            const data = await response.json();
            if (data.token) {
                localStorage.setItem('adminToken', data.token);
                navigate('/jf-secure-2024/dashboard');
            } else {
                setError(data.error || 'Invalid credentials');
            }
        } catch (err) {
            setError('Server se connect nahi ho pa raha.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <main className="bg-dark-300 min-h-screen flex items-center justify-center px-4">
            <div className="w-full max-w-md">

                <div className="bg-dark-200 border border-gray-800 rounded-3xl p-8">

                    {/* Header */}
                    <div className="text-center mb-8">
                        <span className="text-saffron-500 font-display text-3xl font-bold">
                            Job<span className="text-white">Freedom</span>
                        </span>
                        <p className="text-gray-400 text-sm mt-2">Admin Panel</p>
                    </div>

                    {error && (
                        <div className="bg-red-500/10 border border-red-500/30 text-red-400 text-sm rounded-xl px-4 py-3 mb-6">
                            ❌ {error}
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="flex flex-col gap-5">
                        <div>
                            <label className="text-gray-400 text-sm mb-2 block">Email</label>
                            <input
                                type="email" name="email" required
                                value={formData.email} onChange={handleChange}
                                placeholder="admin@jobfreedom.in"
                                className="w-full bg-dark-300 border border-gray-700 focus:border-saffron-500 text-white rounded-xl px-4 py-3 outline-none transition placeholder-gray-600"
                            />
                        </div>

                        <div>
                            <label className="text-gray-400 text-sm mb-2 block">Password</label>
                            <input
                                type="password" name="password" required
                                value={formData.password} onChange={handleChange}
                                placeholder="••••••••"
                                className="w-full bg-dark-300 border border-gray-700 focus:border-saffron-500 text-white rounded-xl px-4 py-3 outline-none transition placeholder-gray-600"
                            />
                        </div>

                        <button
                            type="submit" disabled={loading}
                            className="w-full bg-saffron-500 hover:bg-saffron-600 disabled:opacity-70 text-white font-semibold py-4 rounded-full transition shadow-lg shadow-saffron-500/30"
                        >
                            {loading ? 'Logging in...' : 'Login करो →'}
                        </button>
                    </form>

                    <p className="text-center text-gray-600 text-xs mt-6">
                        Sirf authorized admin hi login kar sakte hain
                    </p>

                </div>
            </div>
        </main>
    );
}

export default AdminLogin;